import React from 'react';
import { NotificationsCentreState } from 'src/components/NotificationsCentre/NotificationsCentreState';
import { observer } from 'src/utils/mobx-react';
import { BetReferralNotification } from 'src/components/NotificationsCentre/BetReferralNotification/BetReferralNotification';
import { NotificationListItem, NotificationsList } from 'src/components/NotificationsCentre/NotificationsCentre.style';
import { useCommon } from 'src/AppState/Common';

export const BetReferralNotificationsList = observer('BetReferralNotificationsList', () => {
    const common = useCommon();
    const state = NotificationsCentreState.get(common);

    const notifications = state.betReferralNotifications;
    const pendingBetReferralItems: Array<JSX.Element> = [];
    const ongoingBetReferralItems: Array<JSX.Element> = [];
    const currentStaffAccountId = $appState.sdkStaff.getStaffId();

    for (const notification of notifications) {
        const id = notification.id;

        const item = (
            <BetReferralNotification
                betReferralNotification={notification}
                currentStaffAccountId={currentStaffAccountId}
                onAssignTrader={state.onAssignTraderHandle}
            />
        );

        if (notification.status === 'pending') {
            pendingBetReferralItems.push(
                <NotificationListItem
                    key={id}
                    data-test='notifications-list-item'
                >
                    {item}
                </NotificationListItem>
            );
        } else {
            ongoingBetReferralItems.push(
                <NotificationListItem
                    key={id}
                    data-test='notifications-list-item'
                >
                    {item}
                </NotificationListItem>
            );
        }
    }

    return (
        <NotificationsList>
            {pendingBetReferralItems}
            {ongoingBetReferralItems}
        </NotificationsList>
    );
});
